// MA-291 — /claim/:code, the parent-activation deep link the teacher's
// share snippet (MA-290) and send-home notes point to. Public (see
// App.jsx's /claim/ gate-ladder bypass — the /join/ precedent). See
// ClaimRedemption.tsx's header for exactly what this route does and,
// deliberately, does not do.
import { createFileRoute } from "@tanstack/react-router";
import { ClaimRedemption } from "@/screens/ClaimRedemption";

function ClaimRoute() {
  const { code } = Route.useParams();
  return <ClaimRedemption code={code} />;
}

export const Route = createFileRoute("/claim/$code")({
  component: ClaimRoute,
});
